import { useTranslation } from 'react-i18next';
import './Helper.css';

export const EnumTranslate = ({ data }) => {
  const { t } = useTranslation();

  if (data)
    if (!Array.isArray(data)) {
      return t('enum.' + data.toLowerCase());
    }

  return data;
};

export default EnumTranslate;
